import React, { useEffect, useState } from 'react';
import './OrientationLock.css';

/**
 * Component that locks the app to landscape orientation
 * Shows a message if the device is in portrait mode
 */
function OrientationLock({ children }) {
  const [isPortrait, setIsPortrait] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      // Check if width < height (portrait) or use orientation API
      const isPortraitMode = window.innerWidth < window.innerHeight;
      setIsPortrait(isPortraitMode);
      
      // Update body class to prevent scrolling when in portrait
      if (isPortraitMode) {
        document.body.classList.add('orientation-locked');
      } else {
        document.body.classList.remove('orientation-locked');
      }
    };

    // Check on mount
    checkOrientation();

    // Listen for orientation changes
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);

    // Try to lock orientation to landscape (if supported)
    if (screen.orientation && screen.orientation.lock) {
      screen.orientation.lock('landscape').catch(() => {
        // Locking failed (not supported or user denied) — expected on many desktops/browsers
      });
    }

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
      document.body.classList.remove('orientation-locked');
    };
  }, []);

  if (isPortrait) {
    return (
      <div className="orientation-lock-message">
        <div className="orientation-lock-content">
          <h2>Please Rotate Your Device</h2>
          <p>This game requires landscape orientation.</p>
          <p>Please rotate your device to continue.</p>
          <div className="orientation-lock-icon">📱</div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

export default OrientationLock;

